import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { AllotmentLetterListModel } from "src/app/model/AllotmentLetterListModel";
import { LettersService } from "src/app/services/letters.service";
import { LetterListModel } from "src/app/model/LetterListModel";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-secure-letters-generate-list",
  templateUrl: "./letters-generate-list.component.html",
  styleUrls: ["./letters-generate-list.component.scss"],
})
export class LettersListComponent implements OnInit, AfterViewInit {
  page: Page<AllotmentLetterListModel>;
  letterList : Page<LetterListModel>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  lotteryList: {[key: number]: string};
  schemeList: {[key: number]: string};
  categoryList: {[key: number]: string};
  dataSource: MatTableDataSource<LetterListModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    "applicantName",
    "lsct",
    "noc",
    "warning",
    "status",
    "action",    
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  
  filteredListParams: {
    letterType: string,
    lotteryEventId: number,
    schemeId: number,
    categoryId: number,
    filterText: string,
    applicationDrawStatus: string,
    unsignedAllotmentGenerationStatus: string,
    unsignedPossessionGenerationStatus: string,
    unsignedPOLGenerationStatus: string,
    pendingDocOrWarn: string
  };

  letterTypes: string[] = ["UN-SIGNED_LOI", "UN-SIGNED_POL", "DRAFT_ALLOTMENT_LETTER", "UN-SIGNED_ALLOTMENT_LETTER", "UN-SIGNED_POSSESSION_LETTER" /*"UN-SIGNED_POL", "SIGNED_LOI","POL","ALLOTMENT_LETTER","POSSESSION_LETTER"*/];
  applicationDrawStatuses: string[] = ["DRAW_WINNER", "DRAW_WAITLIST_ACTIVATED"];

  constructor(
    private letterService: LettersService,
    private _snackBar: MatSnackBar, private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    let storedFilter = localStorage.getItem("app-secure-letter-generate-filterText");
    console.log('storedFilter', storedFilter);
    
    this.filterForm = new FormGroup({
      letterType: new FormControl(null, Validators.required),
      lottery: new FormControl(null, Validators.required),
      scheme: new FormControl(null),
      category: new FormControl(null),
      filterText: new FormControl(null, [Validators.minLength(3)]),
      applicationDrawStatus: new FormControl(null, [Validators.required]),
    });
    
    this.letterService.initPage().subscribe((data: any) => {
      this.isLoading = false;
      if (data.status === "SUCCESS") {
        this.lotteryList = data.lotteryList;
        
        if(storedFilter) {
          this.filteredListParams = JSON.parse(storedFilter);
          console.log('this.filteredListParams', this.filteredListParams);
          if(this.filteredListParams?.lotteryEventId) {
            let selectedLottery = this.lotteryList[this.filteredListParams.lotteryEventId];
            if(this.filteredListParams?.letterType) {
              this.onChangeLetterType(this.filteredListParams?.letterType, true);
            }

            this.filterForm.patchValue({
              letterType: this.filteredListParams?.letterType,
              lottery: {key: this.filteredListParams?.lotteryEventId, value: selectedLottery},
              filterText: this.filteredListParams?.filterText,
              applicationDrawStatus: this.filteredListParams?.applicationDrawStatus,
              unsignedAllotmentGenerationStatus: this.filteredListParams?.unsignedAllotmentGenerationStatus,
              unsignedPossessionGenerationStatus: this.filteredListParams?.unsignedPossessionGenerationStatus,
              unsignedPOLGenerationStatus: this.filteredListParams?.unsignedPOLGenerationStatus,
              pendingDocOrWarn: this.filteredListParams?.pendingDocOrWarn
            });
          }
        }

        if(storedFilter) {
            this.filteredListParams = JSON.parse(storedFilter);
            console.log('this.filteredListParams', this.filteredListParams);
            if(this.filteredListParams.lotteryEventId) {
              let selectedLottery = this.lotteryList[this.filteredListParams.lotteryEventId];

              this.loadSchemes({key: this.filteredListParams.lotteryEventId, value: selectedLottery}, () => {
                if (this.filterForm.valid) {
                  let selectedScheme = this.filteredListParams?.schemeId ? this.schemeList[this.filteredListParams?.schemeId] : null;

                  if(this.filteredListParams?.schemeId) {
                    this.loadCategories({key: this.filteredListParams.schemeId, value: selectedScheme}, () => {
                      let selectedCategory = this.filteredListParams?.categoryId ? this.categoryList[this.filteredListParams?.categoryId] : null;
                      
                      if(this.filteredListParams?.letterType) {
                        this.onChangeLetterType(this.filteredListParams?.letterType, true);
                      }

                      this.filterForm.patchValue({
                        scheme: this.filteredListParams?.schemeId ? {key: this.filteredListParams?.schemeId, value: selectedScheme} : null,
                        category: this.filteredListParams?.categoryId ? {key: this.filteredListParams?.categoryId, value: selectedCategory} : null,
                      });

                      this.onDataLoad();
                    });
                  }
                  else {
                    if(this.filteredListParams?.letterType) {
                      this.onChangeLetterType(this.filteredListParams?.letterType, true);
                    }

                    this.filterForm.patchValue({
                      scheme: this.filteredListParams?.schemeId ? {key: this.filteredListParams?.schemeId, value: selectedScheme} : null,
                      category: null,
                    });
                    
                    this.onDataLoad();
                  }
                }
              });
            }
          }
        } 
        else {
          this.letterService.errorToast(data.errorMessage);
        }
      }, (error) => {
        this.isLoading = false;
        this.letterService.errorToast(error?.error?.errorMessage || error?.error?.message);
      }
    );

    
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onDataLoad();
    }
    else {
      this._snackBar.open("Please Select Mandatory fields", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  resetFilter() {
    localStorage.removeItem("app-secure-letter-generate-filterText");
    this.ngOnInit();
  }

  removeSearchedListAndSavedFilter() {
    this.filteredListParams = null;
    localStorage.removeItem("app-secure-letter-generate-filterText");
    this.letterList = null;
    this.dataSource = null;
    this.paginator.pageIndex = 0;
    this.paginator.length = 0; 
  }
  
  onChangeLetterType(value, load) {
    console.log(value);
    this.filterForm.removeControl("unsignedAllotmentGenerationStatus");
    this.filterForm.removeControl("unsignedPossessionGenerationStatus");
    this.filterForm.removeControl("unsignedPOLGenerationStatus");
    this.filterForm.removeControl("pendingDocOrWarn");

    if(!load) {
      this.removeSearchedListAndSavedFilter();
    }
    if(value === 'UN-SIGNED_ALLOTMENT_LETTER') {
      this.filterForm.addControl("unsignedAllotmentGenerationStatus", new FormControl(null, Validators.required));
      this.filterForm.addControl("pendingDocOrWarn", new FormControl("N", Validators.required));
    }
    else if(value === 'DRAFT_ALLOTMENT_LETTER') {
      this.filterForm.addControl("pendingDocOrWarn", new FormControl("N", Validators.required));
    }
    else if(value === 'UN-SIGNED_POL') {
      this.filterForm.addControl("unsignedPOLGenerationStatus", new FormControl(null, Validators.required));
    }
    else if(value === 'UN-SIGNED_POSSESSION_LETTER') {
      this.filterForm.addControl("unsignedPossessionGenerationStatus", new FormControl(null, Validators.required));
      this.filterForm.addControl("pendingDocOrWarn", new FormControl("N", Validators.required));
    }
    else {
      this.filterForm.removeControl("unsignedAllotmentGenerationStatus");
      this.filterForm.removeControl("unsignedPossessionGenerationStatus");
      this.filterForm.removeControl("unsignedPOLGenerationStatus");
      this.filterForm.removeControl("pendingDocOrWarn");
    }
  }

  loadSchemes(lottery: {key: number, value: string}, callback) {
    this.schemeList = {};
    if(!callback) {
      this.removeSearchedListAndSavedFilter();
    }
    if(lottery?.key) {
      this.isLoading = true;
      this.letterService.fetchSchemeForLotteryEvent(lottery?.key).subscribe((data: any) => {
          this.isLoading = false;
          if (data.status === "SUCCESS") {
            this.schemeList = data.schemeList;
  
            if(callback) {
              callback();
            }
          } 
          else {
            this.letterService.errorToast(data.errorMessage);
          }
        }, (error) => {
          this.isLoading = false;
          this.letterService.errorToast(error?.error?.errorMessage || error?.error?.message);
        }
      );
    }
  }

  loadCategories(scheme: {key: number, value: string}, callback) {
    this.categoryList = {};
    
    if(!callback) {
      this.removeSearchedListAndSavedFilter();
    }
    
    if(scheme?.key) {
      this.isLoading = true;
      this.letterService.fetchCategoryForScheme(scheme?.key).subscribe((data: any) => {
          this.isLoading = false;
          if (data.status === "SUCCESS") {
            this.categoryList = data.categoryList;
  
            if(callback) {
              callback();
            }
          } 
          else {
            this.letterService.errorToast(data.errorMessage);
          }
        }, (error) => {
          this.isLoading = false;
          this.letterService.errorToast(error?.error?.errorMessage || error?.error?.message);
        }
      );
    }
  }

  onDataLoad() {
    this.isLoading = true;
    this.isSearchDisabled = true;
    this.filteredListParams = {
      letterType: this.filterForm.value?.letterType,
      lotteryEventId: this.filterForm.value?.lottery?.key,
      schemeId: this.filterForm.value?.scheme?.key,
      categoryId: this.filterForm.value?.category?.key,
      filterText: this.filterForm.value?.filterText,
      applicationDrawStatus: this.filterForm.value?.applicationDrawStatus,
      unsignedAllotmentGenerationStatus: this.filterForm.value?.unsignedAllotmentGenerationStatus,
      unsignedPossessionGenerationStatus: this.filterForm.value?.unsignedPossessionGenerationStatus,
      unsignedPOLGenerationStatus: this.filterForm.value?.unsignedPOLGenerationStatus,
      pendingDocOrWarn: this.filterForm.value?.pendingDocOrWarn
    };
    localStorage.setItem("app-secure-letter-generate-filterText", JSON.stringify(this.filteredListParams));

    console.log(this.filterForm.value?.schemeFilter);
    
    this.letterService.fetchApplicationListForLetterType(
      this.currentPage,
      this.pageSize,
      this.filterForm.value?.letterType,
      this.filterForm.value?.lottery?.key,
      this.filterForm.value?.scheme?.key,
      this.filterForm.value?.category?.key,
      this.filterForm.value?.filterText,
      this.filterForm.value?.applicationDrawStatus,
      this.filterForm.value?.unsignedAllotmentGenerationStatus,
      this.filterForm.value?.unsignedPossessionGenerationStatus,
      this.filterForm.value?.unsignedPOLGenerationStatus,
      this.filterForm.value?.pendingDocOrWarn
    ).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          console.log(data);
          this.letterList = data.data;
          this.dataSource = new MatTableDataSource(data.data.content);
          
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = data.data.totalElements;
          });
    
          this.isSearchDisabled = false;
        }
        else {
          this.letterService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
        this.letterService.errorToast(error?.error?.errorMessage||error?.errorMessage);
      }
    );
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onDataLoad();
  }

  downloadAllLetter() {
    this.isLoading = true;
    this.letterService.downloadAllLetter(
      this.filteredListParams?.letterType,
      this.filteredListParams?.lotteryEventId,
      this.filteredListParams?.schemeId,
      this.filteredListParams?.categoryId,
      this.filteredListParams?.filterText,
      this.filteredListParams?.applicationDrawStatus,
      this.filteredListParams?.unsignedAllotmentGenerationStatus,
      this.filteredListParams?.unsignedPossessionGenerationStatus,
      this.filteredListParams?.unsignedPOLGenerationStatus,
      this.filterForm.value?.pendingDocOrWarn
    ).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadFile(data.base64File, data.fileName);
        }
        else {
          this.letterService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }

  downloadLetter(applicationId: number) {
    this.isLoading = true;
    this.letterService.downloadLetter(this.filteredListParams?.letterType, applicationId, 
      this.filterForm.value?.unsignedPossessionGenerationStatus, 
      this.filterForm.value?.unsignedAllotmentGenerationStatus, 
      this.filteredListParams?.unsignedPOLGenerationStatus).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadFile(data.base64File, data.fileName);
        }  
        else {
          this.letterService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }

  viewClassForLetterStatus(letterStatus: string) {
    if(letterStatus === 'UNSIGN_ALLOTMENT_GENERATED' || letterStatus === 'UNSIGN_POSSESSION_GENERATED') {
        return 'bg-blue-400';
    }
    else if(["DRAW_WINNER", "DRAW_WAITLIST_ACTIVATED"].indexOf(letterStatus) >= 0) {
        return 'bg-green-400';
    }
    else if(["LOI_NOT_PUBLISHED", "DRAW_WINNER_SURRENDERED", 
      "DRAW_WAITLIST_SURRENDERED", "DRAW_WINNER_OPERATED", "DRAW_WAITLIST_OPERATED"].indexOf(letterStatus) >= 0) {
        return 'bg-pink-600';
    }
    else {
        return '';
    }
  }

  showBDD(o1: any, o2: any) {
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }  
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();
    link.remove();
  }

  async generateUnsignedPOL(applicationId: number) {
    let spouseNameCheckFlag = true;
    this.isLoading = true;
    let letterView = this.letterList.content.find(l => l.applicationId === applicationId);
    if(letterView.maritalStatus === 'Married') {
      if(letterView.gender === 'MALE') {
        console.log('Spouse Name:',letterView.spouseName);
        if(!letterView.spouseName) {
          spouseNameCheckFlag = false;
        }
      }
    }

    if(spouseNameCheckFlag) {
      this.letterService.generateUnsignedPOL(applicationId).subscribe((data) => {
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.downloadFile(data.base64File, data.fileName);
            this.onDataLoad();
          }  
          else {
            this.letterService.errorToast(data.errorMessage, 18000);
          }
        }, (error) => {
          console.log(error);
          this.isLoading = false;
        }
      );
    }
    else {
      this.isLoading = false;
      this.letterService.errorToast("Unable to generate POL - Spouse Name not found. Please ask applicant to Upload Spouse PAN.");
    }
  }

  async generateUnsignedAllotmentLetter(applicationId: number) {
    let spouseNameCheckFlag = true;
    this.isLoading = true;
    let letterView = this.letterList.content.find(l => l.applicationId === applicationId);
    if(letterView.maritalStatus === 'Married') {
      if(letterView.gender === 'MALE') {
        console.log('Spouse Name:',letterView.spouseName);
        if(!letterView.spouseName) {
          spouseNameCheckFlag = false;
        }
      }
    }

    if(spouseNameCheckFlag) {
      this.letterService.generateUnsignedAllotmentLetter(applicationId).subscribe((data) => {
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.downloadFile(data.base64File, data.fileName);
            this.onDataLoad();
          }  
          else {
            this.letterService.errorToast(data.errorMessage, 18000);
          }
        }, (error) => {
          console.log(error);
          this.isLoading = false;
        }
      );
    }
    else {
      this.isLoading = false;
      this.letterService.errorToast("Unable to generate Allotment Letter - Spouse Name not found. Please ask applicant to Upload Spouse PAN.");
    }
  }

  async viewDraftAllotmentLetter(applicationId: number) {
    let spouseNameCheckFlag = true;
    this.isLoading = true;
    let letterView = this.letterList.content.find(l => l.applicationId === applicationId);
    if(letterView.maritalStatus === 'Married') {
      if(letterView.gender === 'MALE') {
        console.log('Spouse Name:',letterView.spouseName);
        if(!letterView.spouseName) {
          spouseNameCheckFlag = false;
        }
      }
    }

    if(spouseNameCheckFlag) {
      this.letterService.viewDraftAllotmentLetter(applicationId).subscribe((data) => {
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.downloadFile(data.base64File, data.fileName);
            this.onDataLoad();
          }  
          else {
            this.letterService.errorToast(data.errorMessage, 18000);
          }
        }, (error) => {
          console.log(error);
          this.isLoading = false;
        }
      );
    }
    else {
      this.isLoading = false;
      this.letterService.errorToast("Unable to view Draft Allotment Letter - Spouse Name not found. Please ask applicant to Upload Spouse PAN.");
    }
  }

  async publishDraftAllotmentLetter(applicationId: number) {
    let spouseNameCheckFlag = true;
    this.isLoading = true;
    let letterView = this.letterList.content.find(l => l.applicationId === applicationId);
    if(letterView.maritalStatus === 'Married') {
      if(letterView.gender === 'MALE') {
        console.log('Spouse Name:',letterView.spouseName);
        if(!letterView.spouseName) {
          spouseNameCheckFlag = false;
        }
      }
    }

    if(spouseNameCheckFlag) {
      this.letterService.publishDraftAllotmentLetter(applicationId).subscribe((data) => {
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.letterService.successToast('Draft Allotment Letter Published');
            this.onDataLoad();
          }  
          else {
            this.letterService.errorToast(data.errorMessage, 18000);
          }
        }, (error) => {
          console.log(error);
          this.isLoading = false;
        }
      );
    }
    else {
      this.isLoading = false;
      this.letterService.errorToast("Unable to publish Draft Allotment Letter - Spouse Name not found. Please ask applicant to Upload Spouse PAN.");
    }
  }

  async generateUnsignedPossessionLetter(applicationId: number) {
    let spouseNameCheckFlag = true;
    this.isLoading = true;
    let letterView = this.letterList.content.find(l => l.applicationId === applicationId);
    if(letterView.maritalStatus === 'Married') {
      if(letterView.gender === 'MALE') {
        console.log('Spouse Name:',letterView.spouseName);
        if(!letterView.spouseName) {
          spouseNameCheckFlag = false;
        }
      }
    }

    if(spouseNameCheckFlag) {
      this.letterService.generateUnsignedPossessionLetter(applicationId).subscribe((data) => {
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.downloadFile(data.base64File, data.fileName);
            this.onDataLoad();
          }  
          else {
            this.letterService.errorToast(data.errorMessage, 18000);
          }
        }, (error) => {
          console.log(error);
          this.isLoading = false;
        }
      );
    }
    else {
      this.isLoading = false;
      this.letterService.errorToast("Unable to generate Possession Letter - Spouse Name not found. Please ask applicant to Upload Spouse PAN.");
    }
  }

  sendPossessionLetterForEsign(applicationId: number) {
    this.isLoading = true;
    this.letterService.sendPossessionLetterForEsign(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.letterService.successToast("Possession Letter sent for Applicant E-Sign");
          this.onDataLoad();
        }  
        else {
          this.letterService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );    
  }

  resendPossessionLetterForEsign(applicationId: number) {
    this.isLoading = true;
    this.letterService.sendPossessionLetterForEsign(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.letterService.successToast("Possession Letter re-sent for Applicant E-Sign");
          this.onDataLoad();
        }  
        else {
          this.letterService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );    
  }

  checkEsignStatusForPossession(applicationId: number) {
    this.isLoading = true;
    this.letterService.checkEsignStatusForPossession(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.letterService.successToast("Possession Letter E-Sign complete");
          this.onDataLoad();
        }  
        else {
          this.letterService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );    
  }

  signWithDSC(applicationId: number) {
    this.isLoading = true;
    this.letterService.signWithDSC(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.onDataLoad();
          window.open(data.redirectUrl, "_blank");
        }  
        else {
          this.letterService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.letterService.errorToast(error?.error?.errorMessage||error?.errorMessage, 18000);
      }
    );
  }
  
  signWithDSCAllotment(applicationId: number) {
    this.isLoading = true;
    this.letterService.signWithDSCAllotment(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.onDataLoad();
          window.open(data.redirectUrl, "_blank");
        }  
        else {
          this.letterService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.letterService.errorToast(error?.error?.errorMessage||error?.errorMessage, 18000);
      }
    );
  }

  checkPossessionDSCSignStatus(applicationId: number) {
    this.isLoading = true;
    this.letterService.checkPossessionDSCSignStatus(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.letterService.successToast("Possession Letter DSC Sign complete");
          this.onDataLoad();
        }  
        else {
          this.letterService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.letterService.errorToast(error?.error?.errorMessage||error?.errorMessage, 18000);
      }
    );
  }

  checkAllotmentDSCSignStatus(applicationId: number) {
    this.isLoading = true;
    this.letterService.checkAllotmentDSCSignStatus(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.letterService.successToast("Allotment Letter DSC Sign complete");
          this.onDataLoad();
        }  
        else {
          this.letterService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.letterService.errorToast(error?.error?.errorMessage||error?.errorMessage, 18000);
      }
    );
  }

  publishPossessionLetter(applicationId: number) {
    this.isLoading = true;
    this.letterService.publishPossessionLetter(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.letterService.successToast("Possession Letter successfully published");
          this.onDataLoad();
        }  
        else {
          this.letterService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.letterService.errorToast(error?.error?.errorMessage||error?.errorMessage, 18000);
      }
    );
  }

  publishAllotmentLetter(applicationId: number) {
    this.isLoading = true;
    this.letterService.publishAllotmentLetter(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.letterService.successToast("Allotment Letter successfully published");
          this.onDataLoad();
        }  
        else {
          this.letterService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.letterService.errorToast(error?.error?.errorMessage||error?.errorMessage, 18000);
      }
    );
  }

  showText(o1: any, o2: any) {   
    console.log('showText', o1, o2, o1 == o2); 
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }

  showObj(o1: any, o2: any) {    
    console.log('showObj', o1, o2, o1 == o2); 
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }
}